import React, { useEffect, useState } from "react";
import { Col, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import axios from "axios";
import { Deducibles } from "./Deducibles";
import { useBoolean } from "../../custom-hooks/useBoolean";
import { ReactComponent as IconIsLoading } from "../../assets/img/icon/loading.svg";

const LOADING_SIZE = 56;
const EXCLUDED_RAMOS = ["VIDA"];

export const DeduciblesModal = ({ base, cedula, toggleModal, open }) => {
    const [list, setList] = useState([]);
    const { value: isLoading, setFalse: setIsLoadingFalse, setTrue: setIsLoadingTrue } = useBoolean();

    const getDeducibles = cedula => {
        setIsLoadingTrue();
        axios
            .get(base + "/siniestro/deducible/matrix", {
                params: { cedula, caducada: false },
            })
            .then(resp => {
                setList(excludeDeductiblesByRamo(resp.data));
            })
            .catch(error => {
                alert("Error al consultar" + error);
            })
            .finally(setIsLoadingFalse);
    };

    useEffect(() => {
        if (open && cedula) {
            getDeducibles(cedula);
        }
    }, [open, cedula]);

    const closeModal = () => {
        toggleModal(false);
        setList([]);
    };

    const excludeDeductiblesByRamo = deductibles => {
        return deductibles.filter(deductible => !EXCLUDED_RAMOS.some(ramo => deductible.NM_RAMO.includes(ramo)));
    };

    return (
        <Modal className="text-center modal-dialog-centered modal-lg" isOpen={open}>
            <ModalHeader className="justify-content-center title" tag="h4">
                Deducibles
                <button type="button" className="close" title="Cerrar" onClick={closeModal} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody className={"pt-0 mt-0"}>
                {isLoading ? (
                    <div className={"d-flex justify-content-center align-items-center py-3"}>
                        <h3 className={"text-primary m-0 mr-2"}>Cargando</h3>
                        <IconIsLoading className={"svg-primary fa-spin"} width={LOADING_SIZE} height={LOADING_SIZE} />
                    </div>
                ) : (
                    list.map(p => (
                        <div key={p.CD_COTIZACION}>
                            <div className="row">
                                <div className="col-sm-2 text-primary text-right st-160">Aseguradora:</div>
                                <div className={"col-auto text-left"}>{p.ASEGURADORA}</div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 text-primary text-right st-160">Póliza:</div>
                                <div className={"col-auto text-left"}>{p.POLIZA}</div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 text-primary text-right st-160">Grupo:</div>
                                <div className={"col-auto text-left"}>{p.DSC_UBICACION}</div>
                            </div>
                            <div className="row">
                                <div className="col-sm-2 text-primary text-right st-160">Contratante:</div>
                                <div className={"col-auto text-left"}>{p.CLIENTE}</div>
                            </div>
                            <div className="row">
                                <Col xs={12} sm={6} />
                                <Col xs={12} sm={6}>
                                    <div className="row">
                                        <div className=" col-lg-8 mx-md-auto">
                                            <small className="align-items-center text-primary">
                                                <i className="fas fa-circle mr-2 m-lg-0" />
                                                <Label className="m-2"> Aplicado </Label>
                                            </small>
                                            <small className="align-items-center text-primary">
                                                <i className="fas fa-circle mr-2 text-yellow m-lg-0" />
                                                <Label className="m-2"> Por Aplicar </Label>
                                            </small>
                                        </div>
                                    </div>
                                </Col>
                            </div>
                            <table>
                                <tbody>
                                    {p.items.map(d => (
                                        <tr key={d.CEDULA + "" + p.CD_COTIZACION}>
                                            <td className={"text-right"}>
                                                <small className={"text-primary"}>{d.NOMBRES}</small>
                                            </td>
                                            <td>
                                                <Deducibles deducible={d.deducible} space={true} />
                                            </td>
                                        </tr>
                                    ))}

                                    {(p.items || []).length === 0 && (
                                        <tr>
                                            <td colSpan={2}>Sin Deducibles</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <hr className={"border border-bottom border-primary"} />
                        </div>
                    ))
                )}
            </ModalBody>
        </Modal>
    );
};
